import React from "react";
import Snap from "snapsvg-cjs";

import rollingBridge from "../images/svg/rollingBridge02.svg";
import "./Animation.css";
 
// mina is not exported from snapsvg-cjs
const mina = window.mina;

class RollingBridge extends React.Component {

	componentDidMount() {
		// Set ready to false
		this.props.setReadyState(false);
		// Allows to assign this to an attr in parent
		this.props.onRef(this);
		// Load SVG into the component
		this.svg = Snap(document.querySelector("#rollingBridge"));
		Snap.load(
			rollingBridge,
			function (data) {
				this.svg.append(data);
				// Set ready to true
				this.props.setReadyState(true);
			}.bind(this),
		);
	}
	
	animate() {
	
		var angle = 0;

		var tri8 = Snap.select("#rollingBridge #tri8"); 
		var tri7 = Snap.select("#rollingBridge #tri7"); 
		var tri6 = Snap.select("#rollingBridge #tri6"); 
		var tri5 = Snap.select("#rollingBridge #tri5"); 
		var tri4 = Snap.select("#rollingBridge #tri4"); 
		var tri3 = Snap.select("#rollingBridge #tri3"); 
		var tri2 = Snap.select("#rollingBridge #tri2"); 
		// var tri02 = Snap.select("#rollingBridge #tri02");
		// var anchor01 = tri02.split(" ");
		// var anchor01 = tri02[1];
		// console.log(anchor01);

		var unrollAnimation = () => Snap.animate(
			0,
			1,
			function (step) {
				var m = new Snap.Matrix();

				tri8.attr({ transform: m.rotate(-angle, 247.8, 343.2) });
				//tri7.appendTo( tri8 );
				tri7.attr({ transform: m.rotate(-angle, 184.6, 280) });
				//tri6.appendTo( tri7 );
				tri6.attr({ transform: m.rotate(-angle, 184.6, 190.6) });
				// group03.appendTo( group04 );
				tri5.attr({ transform: m.rotate(-angle, 247.8, 127.4 ) });
				// group02.appendTo( group03 );
				tri4.attr({ transform: m.rotate(-angle, 337.1, 127.4) });
				// group01.appendTo( group02 );
				tri3.attr({ transform: m.rotate(-angle, 400.3, 190.6) });

				tri2.attr({ transform: m.rotate(-angle, 400.3, 280) });

				angle = step * 45.;
				
			}.bind(this),
			3000,
			mina.backout,
			function () {
				// Animation complete
				this.props.onAnimationEnd();
			}.bind(this)
		);
		unrollAnimation();
	}


	render() {
		return (
            <div>
            <svg id="rollingBridge"
				viewBox="-250 100 640 380"
				xmlns="http://www.w3.org/2000/svg"
				preserveAspectRatio="xMidYMid meet">
			</svg>
            {/* for testing */}
            {/* <div onClick={this.animate.bind(this)}>animate me!2</div> */}
			</div>
		);
	}
}

export default RollingBridge








// WEBPACK FOOTER //
// ./src/animation/RollingBridge.js